import React from "react";
import { useParams } from "react-router-dom";

export const WorkflowDatasetsPage: React.FC = () => {
  const { workflowId } = useParams();

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Datasets for Workflow {workflowId}</h1>
      <div className=" rounded-lg shadow p-4">{/* Add your datasets content here */}</div>
    </div>
  );
};
